// Curated red-onion imagery (self-hosted under /public/landing).
// Sourced from Unsplash; see PHOTO_CREDITS for attribution.
export const LANDING_IMAGES = {
  hero: '/landing/hero-onions.jpg',
  field: '/landing/field.jpg',
  market: '/landing/market.jpg',
} as const;

// Real photos for each onion grade — used as a fallback when no
// Firestore product_photos image is configured for that grade.
export const GRADE_IMAGES: Record<string, string> = {
  'red-md': '/landing/grade-md.jpg',
  'red-lg': '/landing/grade-lg.jpg',
  'red-sm': '/landing/grade-sm.jpg',
};

// Feature-card imagery (Direct from farm / Same-day delivery / Quality guarantee).
export const FEATURE_IMAGES = {
  farm: '/landing/feat-farm.jpg',
  delivery: '/landing/feat-delivery.jpg',
  quality: '/landing/feat-quality.jpg',
} as const;

export const PHOTO_CREDITS = 'Photos via Unsplash';
